export default __webpack_public_path__ + "static/media/trash.30789dd0.svg";